<div class="message-dialog" [ngClass]="'type-' + data.type">
  <div class="dialog-header">
    <div class="icon-wrapper" [ngClass]="data.type">
      <i [class]="getIconClass()"></i>
    </div>
    <h2 mat-dialog-title>{{ data.title }}</h2>
  </div>
  <mat-dialog-content>
    <p>{{ data.message }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onClose()" class="close-btn">
      <span>{{ data.buttonText }}</span>
    </button>
  </mat-dialog-actions>
</div>

